import { render, staticRenderFns } from "./MovePresentations.vue?vue&type=template&id=9c935742&scoped=true&"
import script from "./MovePresentations.vue?vue&type=script&lang=js&"
export * from "./MovePresentations.vue?vue&type=script&lang=js&"
import style0 from "./MovePresentations.vue?vue&type=style&index=0&id=9c935742&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c935742",
  null
  
)

export default component.exports